<template>
    <div id="app">
        <login v-if="isInitialized && $route.name==='login'"></login>
        <template v-if="userOnceAuthenticated">
            <Home v-show="atHome"></Home>
            <projects-manager :active-project-id="$route.params.pid" v-show="atProjectSpace"
                              ref="projectsManager"></projects-manager>
        </template>
        <div class="global-message-box flex-column" v-if="initError">
          <h1>Failed to Initialize DocAnalyzer!</h1>
            <button onclick="location.reload()" class="mt-2">Reload</button>
        </div>
        <iframe name="general-iframe" src="" style="display: none"></iframe>
      <dev-space v-if="atDevSpace"></dev-space>
    </div>
</template>

<script>
    import Login from "@/views/Login";
    import {doUserLogout} from "@/apis";
    import {authHelper} from "@/utils";
    import Home from "@/views/Home";
    import {Promise} from 'es6-promise-polyfill';
    import ProjectsManager from "@/views/ProjectsManager";
    import DevSpace from "@/views/DevSpace";

    export default {
      components: {DevSpace, ProjectsManager, Home, Login: Login},
      methods: {
        logout() {
          let p = this.closeAllTabs();

          p.then(() => {
            doUserLogout().then(() => {
              authHelper.setUserAuthenticated(false);
              authHelper.setUserOnceAuthenticated(false);
              this.$router.push({name: 'login'});
            }).catch(() => {
                        alert('There was something not right while logging you out!')
                    })
                })
            },
            closeAllTabs() {
                let p;

                if (this.$refs.projectsManager) {
                    p = this.$refs.projectsManager.closeAllTabs();
                } else {
                    p = Promise.resolve();
                }

                return p;
            },
            closeAllTabsSwiftly() {
                this.$refs.projectsManager && this.$refs.projectsManager.closeAllTabsSwiftly();
            }
        },
        computed: {
            openGlobalDocumentIds() {
                return this.$store.state.openGlobalDocumentIds
            },
            documentCanSubmitMaps() {
                return this.$store.state.documentCanSubmitMaps
            },
            existsUnsavedChanges() {
                function getUnsavedDocuments(openGlobalDocumentIds, documentCanSubmitMaps) {
                    let unsavedDocuments = 0;

                    for (let i = 0; i < openGlobalDocumentIds.length; i++) {
                        if (documentCanSubmitMaps[openGlobalDocumentIds[i]]) {
                            unsavedDocuments++;
                        }
                    }
                    return unsavedDocuments;
                }

                const openGlobalDocumentIds = this.openGlobalDocumentIds;
                const documentCanSubmitMaps = this.documentCanSubmitMaps;

                let unsavedDocuments = 0;

                for (let projectId in openGlobalDocumentIds) {
                    if (openGlobalDocumentIds.hasOwnProperty(projectId)) {
                        unsavedDocuments += getUnsavedDocuments(openGlobalDocumentIds[projectId], documentCanSubmitMaps[projectId] || {});
                    }
                }

                return unsavedDocuments;
            },
            isInitialized() {
                return this.$store.state.isInitialized
            },
            initialUserInfoLoading() {
                return this.$store.state.initialUserInfoLoading
            },
            userInfo() {
                return this.$store.state.userInfo
            },
            initError() {
              return this.$store.state.initError
            },
          userAuthenticated() {
            return this.$store.state.userAuthenticated
          },
          userOnceAuthenticated() {
            return this.$store.state.userOnceAuthenticated
          },
          atHome() {
            return this.$route.name === 'home';
          },
          atProjectSpace() {
            return this.$route.name in {
              'document_finder': 1,
              'documents': 1,
            }
          },
          atDevSpace() {
            return this.$route.name === 'dev_space';
          }
        },
        watch: {
            existsUnsavedChanges: {
                handler(newVal) {
                    this.$store.commit('setExistsUnsavedChanges', newVal);

                    window.onbeforeunload = () => {
                        if (newVal) {
                            return false;
                        } else {
                            this.closeAllTabsSwiftly();
                        }
                    }
                },
                immediate: true
            },
        },
        mounted() {
            window.onunload = () => {
                this.closeAllTabsSwiftly();
            };
            this.doLogoutListener = () => {
              this.logout();
            };
            this.eventHub.$on('doLogout', this.doLogoutListener);

            this.$nextTick(() => {
                document.documentElement.classList.remove('loading')
            });
        },
        data() {
            return {
                doLogoutListener: null,
            }
        },
        destroyed() {
            this.eventHub.$off('doLogout', this.doLogoutListener);
        }
    }
</script>
